import { render } from "./vaccount.vue?vue&type=template&id=2b39ab38&scoped=true"
import script from "./vaccount.vue?vue&type=script&lang=js"
export * from "./vaccount.vue?vue&type=script&lang=js"

import "./vaccount.vue?vue&type=style&index=0&id=2b39ab38&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b39ab38"]])

export default __exports__